import { getV1FormBuilderFieldsId, getV1FormBuilderId, patchV1FormBuilderId } from "@/api-client/api.system-feature/api";
import { GetV1FormBuilderFieldsIdRequest } from "@/api-client/api.system-feature/api-types";
import { getToken } from "@/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const patchFormDataById = createAsyncThunk(

  "formBuilder/put",
  async ({ id, data }: any) => {
    const response = await patchV1FormBuilderId({
      ...getToken(),
      id: id,
      ...data,
    });
    return response;
  },
);

export const getFormDataById = createAsyncThunk(
  "formBuilder/getById",
  async (id: string) => {
    const response = await getV1FormBuilderId({
      ...getToken(),
      id: id,
    });
    return response;
  }
);



export const getFieldsByFormId = createAsyncThunk(
  "formBuilder/fields/get",
  async ({ id }: GetV1FormBuilderFieldsIdRequest) => {
    // id = "661537c19ac80d3d5d0a915a";
    const response: any = await getV1FormBuilderFieldsId({
      ...getToken(),
      id: id,
    });
    return response?.data.fields;
  },
);
